<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CCard>
                    <CCardHeader>
                        <strong>افزودن لینک</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CForm @keyup.enter="validator();submit()">
                            <CRow>
                                <CCol sm="3">
                                    <label>کاربر</label>
                                    <model-select :options="users" v-model="form.user_id.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.user_id.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.url_link.val" :description="form.url_link.inv" dir="ltr" label="لینک" />
                                </CCol>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.is_active.val"
                                        :description="form.is_active.inv"
                                        label="وضعیت"
                                        :options="[
                                            {value: 'true', label:'فعال'},
                                            {value: 'false', label:'غیرفعال'},
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.is_active.val=$event.target.value"
                                    />
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="9">
                                    <CInputCheckbox
                                        v-for="option in options"
                                        v-model="option.value"
                                        true-value="true"
                                        false-value="false"
                                        :key="option.key"
                                        :label="option.label"
                                        :checked="option.value === true"
                                        @change="option.value = $event.target.checked"
                                    />
                                </CCol>
                            </CRow>
                        </CForm>
                        <br>
                        <div class="form-group form-actions">
                            <CButton @click="validator();submit()" color="primary"> افزودن</CButton>
                        </div>    
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import validator from '../mixins'
export default {
    mixins: { validator },
    components: { ModelSelect },
    data() {
        return {
            form: {
				user_id: {val: '', inv: '', v: { req: true, max: 8 }},
                url_link: {val: '', inv: '', v: { req: true, max: 512, spec: 'url' }},
                is_active: {val: '', inv: '', v: { req: true, max: 8 }},
			},
            disable: false,
            users: [],
            options: [
                {key:"add_link_to_all_numbers", label: "افزودن لینک به همه شماره‌ها", value: false},
            ],
            success: 0,
            unsuccess: 0,
        }
    },
    mounted() {
        this.get_users();
	},
    methods: {
        get_users(){
            this.axios.get('users/?type=add_user_links')
            .then(res => {
                res.data.map(val => {
                    this.users.push({value: val.id, text: `${val.id} - ${val.name}`})
                });
            })
        },
        submit(){
            if(this.disable == false){
                const data = new FormData();
                for (const key in this.form){
                    data.set(key, this.form[key].val);
                }
                this.axios.post('user_urls/', data)
                    .then(res => {
                        const id = res.data.id;
                        this.$notify({
                            group: 'foo',
                            type: 'success',
                            text: 'افزودن با موفقیت انجام شد.'
                        });
                        if(this.options[0].value == true){
                            this.$notify({
                                group: 'foo',
                                type: 'success',
                                text: 'افزودن لینک به همه‌ی شماره‌ها در حال انجام است. لطفا صبور باشید.'
                            });
                            this.axios.get('user_nums/?type=view_user_nums')
                                .then(res => {
                                    res.data.map(val => {
                                        const data = new FormData();
                                        data.set('url_id', id);
                                        data.set('user_num_id', val.id);
                                        this.axios.post('url_to_nums/', data)
                                            .then(() => { this.success += 1;})
                                            .catch(() => { this.unsuccess += 1;})
                                    })
                                })
                                if(this.success != 0){
                                    this.$notify({
                                        group: 'foo',
                                        type: 'success',
                                        text: `افزودن لینک به ${success} شماره با موفقیت انجام شد.`
                                    });
                                }
                                if(this.unsuccess != 0){
                                    this.$notify({
                                        group: 'foo',
                                        type: 'error',
                                        text: `افزودن لینک به ${unsuccess} شماره انجام نشد! لطفا مجددا تلاش کنید.`
                                    });
                                }
                        }
                        for (const key in this.form){
                            this.form[key].val = '';
                        }
                    })
                    .catch(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            text: 'خطا! لطفا مجددا تلاش کنید.'
                        });
                    })
            }
        }
    },
	beforeCreate(){
        if(this.$store.state.perms.can_add_link == false
            && this.$store.state.perms.can_add_link_for_all_users == false
            && this.$store.state.perms.can_add_link_for_same_group_user == false
            && this.$store.state.verif == false){
			this.$router.push('/403')
		}
	},
}
</script>
